var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[(!_vm.loading)?_c('router-view'):_c('v-app',[_c('v-main',[_c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('Carregando')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }